import { object, string } from "yup";

import { SelectOption } from "@covertree/ui";
import { PreciselyAddressWithUnit } from "@covertree/features";
import { preciselyAddress } from "@covertree/utils";

export interface HomeAddressForm {
  address: SelectOption<PreciselyAddressWithUnit>;
  unit?: string | null;
}

export const homeAddressFormValidator = object({
  address: preciselyAddress(),
  unit: string().optional().nullable(),
});
